import { render } from "./MoreVerticalIcon.vue?vue&type=template&id=8c88ed00"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__